import React from 'react';
import { isMobilePage } from '../../common/cores';

const Blank = (props) => {
    return (
        <div  className="row col" style= {{ flexDirection: "row" , justifyContent: "center", alignItems: "center", minHeight: "100%", display: (isMobilePage() && !props.showHis) && "none" }}>
                <img data-v-0b388a17=""
                src="../images/logo.635847c.png" alt="Logo" className="logo-img" /></div>
    )
}

export default Blank;


// WEBPACK FOOTER //
// ./src/components/account/Blank.js